import React, { Fragment, useMemo } from 'react'
import { styled, generateUniqueId } from '../../../../utilities';
import PropTypes from 'prop-types'
import { Button, withTheme } from '../../../../common';
import modules from './suggestions.module.scss';
import { BOTNAME_LABEL } from '../../../../utilities/constants';

const StyledTitle  = styled.div`
    ${({ theme = {} }) => {
        const { responseMessage, text } = theme
        return {
            color: responseMessage.text ? responseMessage.text : text ? text : '',
        }
    }}
`;

const StyledSubtitle = styled.div`
  ${({ theme }) => ({
      color: theme.secondary || '',
  })}
`;


const Suggestions = (props = {}) => {
    const { list, handleInput, prefixIdentifier } = props
    if(!Array.isArray(list) || list.length === 0) return null

    const memoizedList = useMemo(() => {
        return list.map((suggestion, index) => {
            const uniqueId = prefixIdentifier ? generateUniqueId(prefixIdentifier, `suggestion-${index}`) : ''
            const { buttons = [], imageUrl, title, subTitle } = suggestion
            const titleId = uniqueId && title ? `${uniqueId}-title` : undefined
            const subTitleId = uniqueId && subTitle ? `${uniqueId}-subTitle` : undefined

            return <Fragment key={uniqueId} >
                <hr />
                {title && <StyledTitle id={titleId} className={modules.title}>
                    {title}
                </StyledTitle>}
                {subTitle && <StyledSubtitle id={subTitleId} className={modules.subtitle}>
                    {subTitle}
                </StyledSubtitle>}
                {imageUrl && <Fragment>
                    <img alt={title || subTitle || ""} src={imageUrl} className={modules.image} />
                </Fragment>}
                {buttons.length > 0 && <div
                    className={modules.buttonGroup}
                    aria-labelledby={titleId}
                    aria-describedby={subTitleId}
                    role="group">
                    <span className="sr-only">Ask {BOTNAME_LABEL}</span>
                    {buttons.map((btn, idx) => <Button outline onClick={() => handleInput(btn.value)} key={`${uniqueId}-button-${idx}`}>
                        {btn.text}
                    </Button>)}
                </div>}
            </Fragment>
        })
    }, [list])

    return memoizedList
    
}

Suggestions.defaultProps = {
    list: [],
    prefixIdentifier: '',
    handleInput: (value) => console.log(`Message Suggestions, Handle Input:`, value)
}

Suggestions.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({
        buttons: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string,
            value: PropTypes.string
        })),
        imageUrl: PropTypes.string,
        title: PropTypes.string,
        subTitle: PropTypes.string,
    })),
    prefixIdentifier: PropTypes.string.isRequired,
    handleInput: PropTypes.func
}

export default withTheme(Suggestions)